import { useEffect, useState } from "react";
import { Activity, AlertTriangle, Database, CreditCard, Mail, Lock, Globe } from "lucide-react";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

const ETICHETTE = {
  backup_ore: "Ore senza backup",
  errori_24h: "Errori al giorno",
  login_falliti: "Accessi negati",
  db_percento: "Database pieno al %",
  cert_giorni: "Giorni al certificato",
  silenzio_ore: "Ore tra due avvisi uguali",
};

/** Come sta il server: errori, tempi, spazio, pagamenti, certificato. Nessun dato dei clienti. */
export const SaluteSistema = ({ client }) => {
  const [h, setH] = useState(null);
  const [mod, setMod] = useState(null);

  const carica = async () => {
    try {
      const r = await client.get("/admin/salute");
      setH(r.data);
    } catch {
      /* la Console resta aperta anche se un giro va a vuoto */
    }
  };
  useEffect(() => {
    carica();
    const i = setInterval(carica, 120000);
    return () => clearInterval(i);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  if (!h) return null;
  const db = h.database || {};
  const cert = h.certificato_giorni;
  const s = h.soglie || {};
  const male = (c) => (c ? "text-rose-300" : "");

  const righe = [
    { k: "Errori del server (24 h)", v: h.richieste.errori, icon: AlertTriangle,
      ko: h.richieste.errori > s.errori_24h },
    { k: "Tempo di risposta medio", v: `${h.richieste.medio_ms} ms`, icon: Activity },
    { k: "95 richieste su 100 entro", v: h.richieste.p95, icon: Activity },
    { k: "Spazio database", v: db.mb == null ? "—" : `${db.mb} MB (${db.percento}%)`,
      icon: Database, ko: db.percento != null && db.percento >= s.db_percento },
    { k: "Pagamenti non notificati", v: h.webhook.falliti, icon: CreditCard, ko: h.webhook.falliti > 0 },    { k: "Email ancora in coda", v: h.email.in_coda, icon: Mail, ko: h.email.in_coda > 0 },
    { k: "Accessi Console negati", v: h.accessi_negati, icon: Lock,
      ko: h.accessi_negati >= s.login_falliti },
    { k: "Certificato", v: cert == null ? "—" : `tra ${cert} giorni`, icon: Globe,
      ko: cert != null && cert <= s.cert_giorni },
    { k: "Dominio", v: h.dominio_giorni == null ? "—" : `tra ${h.dominio_giorni} giorni`, icon: Globe },
  ];

  return (
    <Card className="border-slate-800 bg-[#111827] p-5 text-slate-100" data-testid="console-salute">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.24em] text-slate-400">
          <Activity className="h-4 w-4" /> Salute del sistema
        </p>
        <Button size="sm" variant="outline" data-testid="soglie-btn"
                onClick={() => setMod(mod ? null : { ...s })}>
          {mod ? "Chiudi soglie" : "Soglie avvisi"}
        </Button>
      </div>

      <dl className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {righe.map((r) => (
          <div key={r.k} className={`flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm ${r.ko ? "bg-rose-950/50 ring-1 ring-rose-500" : "bg-slate-900/70"}`}
               data-testid={`salute-${r.k.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <r.icon className={`h-4 w-4 shrink-0 ${r.ko ? "text-rose-300" : "text-slate-500"}`} />
            <span className="min-w-0 flex-1 truncate text-slate-400">{r.k}</span>
            <span className={`font-num font-bold ${male(r.ko)}`}>{r.v}</span>
          </div>
        ))}
      </dl>

      {h.richieste.tipi?.length > 0 && (
        <div className="mt-3" data-testid="salute-tipi-errore">
          <p className="text-[10px] uppercase tracking-wider text-slate-500">Errori per tipo</p>
          <ul className="mt-1 space-y-1 text-xs text-slate-400">
            {h.richieste.tipi.map((t) => (
              <li key={t.tipo}><span className="font-mono">{t.tipo}</span> · {t.quante}</li>
            ))}
          </ul>
        </div>
      )}

      {mod && (
        <div className="mt-4 rounded-lg bg-slate-900/70 p-3" data-testid="soglie-form">
          <div className="grid gap-2 sm:grid-cols-3">
            {Object.keys(ETICHETTE).map((k) => (
              <label key={k} className="text-xs text-slate-400">
                {ETICHETTE[k]}
                <Input value={mod[k] ?? ""} inputMode="numeric" data-testid={`soglia-${k}`}
                       onChange={(e) => setMod({ ...mod, [k]: e.target.value })}
                       className="mt-1 bg-slate-950 text-slate-100" />
              </label>
            ))}
          </div>
          <Button size="sm" className="mt-3" data-testid="soglie-salva"
                  onClick={async () => {
                    await client.patch("/admin/salute/soglie", mod);
                    setMod(null);
                    carica();
                  }}>
            Salva soglie
          </Button>
        </div>
      )}

      <p className="mt-3 text-xs text-slate-500">
        Qui non entrano dati dei clienti: solo conteggi, stati e il codice del locale.
      </p>
    </Card>
  );
};
